import { IColumn } from "@fluentui/react";
import strings from "../../loc/strings";

export const _type: { [key: string]: string } = {
    natural: "Natural",
    legal: "Legal"
};

export enum ErrorColumnFieldName {
    Validation = "validation",
    FailedRules = "failedRules",
    ID = "rowNumber",
    Type = "type",
    FirstName = "firstName",
    LastName = "lastName",
    DateOfBirth = "dateOfBirth",
    CityOfBirth = "cityOfBirth",
    CountryOfBirth = "countryOfBirth",
    AlsoKnownAs = "alsoKnownAs",
    LegalName = "legalName",
    LeiRegistrationNumber = "leiRegistration",
    CountryInc = "countryInc",
    EUSectoralLegislativeBasis = "euSectoralLegislatureBasisId",
    InternalCARefNo = "internalCARefNo",
    SubmissionDate = "submissionDate",
    IdNumber = "idNumber",
    SocialSecurityNumber = "socialSecurityNumber",
    DateOfAssessment = "dateOfAssessment"
}

export const errorIdToColumnKeyMap: { [key: string]: string } = {
    None : "None",
    DateOfBirth : "DateOfBirth",
    Type : "Type",
    DateOfAssessment : "DateOfAssessment",
    SubmissionDate : "SubmissionDate",
    InternalCARefNo : "InternalCARefNo",
    EUSectoralLegislatureBasisId : "EUSectoralLegislatureBasisId",
    FirstName : "FirstName",
    LastName : "LastName",
    CityOfBirth : "CityOfBirth",
    CountryOfBirth : "CountryOfBirth",
    AlsoKnownAs : "AlsoKnownAs",
    LegalName : "LegalName",
    LeiRegistration : "LeiRegistration",
    CountryInc : "CountryInc",
    IdNumber : "IdNumber",
    SocialSecurityNumber : "SocialSecurityNumber",
    ID: "RowNumber"
};

export const _errorColumnsNormal: IColumn[] = [
    {
        key: "Validation",
        name: strings.validationLabel,
        fieldName: ErrorColumnFieldName.Validation,
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
    },
    {
        key: "FailedRules",
        name: strings.failedRulesLabel,
        fieldName: ErrorColumnFieldName.FailedRules,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "RowNumber",
        name: strings.idLabel,
        fieldName: ErrorColumnFieldName.ID,
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
        isSorted: true,
    },
    {
        key: "Type",
        name: strings.typeLabel,
        fieldName: ErrorColumnFieldName.Type,
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
    },
    {
        key: "FirstName",
        name: strings.firstNameLabel,
        fieldName: ErrorColumnFieldName.FirstName,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "LastName",
        name: strings.lastNameLabel,
        fieldName: ErrorColumnFieldName.LastName,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "DateOfBirth",
        name: strings.dateOfBirthLabel,
        fieldName: ErrorColumnFieldName.DateOfBirth,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "CityOfBirth",
        name: strings.cityOfBirthLabel,
        fieldName: ErrorColumnFieldName.CityOfBirth,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "CountryOfBirth",
        name: strings.countryOfBirthLabel,
        fieldName: ErrorColumnFieldName.CountryOfBirth,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "AlsoKnownAs",
        name: strings.alsoKnownAsLabel,
        fieldName: ErrorColumnFieldName.AlsoKnownAs,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "LegalName",
        name: strings.legalNameLabel,
        fieldName: ErrorColumnFieldName.LegalName,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "LeiRegistration",
        name: strings.leiRegistrationNumberLabel,
        fieldName: ErrorColumnFieldName.LeiRegistrationNumber,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "CountryInc",
        name: strings.countryIncLabel,
        fieldName: ErrorColumnFieldName.CountryInc,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "EUSectoralLegislatureBasisId",
        name: strings.EUSecLegBasisLabel,
        fieldName: ErrorColumnFieldName.EUSectoralLegislativeBasis,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "InternalCARefNo",
        name: strings.assessingCALabel,
        fieldName: ErrorColumnFieldName.InternalCARefNo,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "DateOfAssessment",
        name: strings.dateOfAssessmentLabel,
        fieldName: ErrorColumnFieldName.DateOfAssessment,
        minWidth: 100,
        isResizable: true,
    }
];

export const _errorColumnsHistorical: IColumn[] = [
    {
        key: "Validation",
        name: strings.validationLabel,
        fieldName: ErrorColumnFieldName.Validation,
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
    },
    {
        key: "FailedRules",
        name: strings.failedRulesLabel,
        fieldName: ErrorColumnFieldName.FailedRules,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "RowNumber",
        name: strings.idLabel,
        fieldName: ErrorColumnFieldName.ID,
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
        isSorted: true,
    },
    {
        key: "Type",
        name: strings.typeLabel,
        fieldName: ErrorColumnFieldName.Type,
        minWidth: 50,
        maxWidth: 100,
        isResizable: true,
    },
    {
        key: "FirstName",
        name: strings.firstNameLabel,
        fieldName: ErrorColumnFieldName.FirstName,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "LastName",
        name: strings.lastNameLabel,
        fieldName: ErrorColumnFieldName.LastName,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "DateOfBirth",
        name: strings.dateOfBirthLabel,
        fieldName: ErrorColumnFieldName.DateOfBirth,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "CityOfBirth",
        name: strings.cityOfBirthLabel,
        fieldName: ErrorColumnFieldName.CityOfBirth,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "CountryOfBirth",
        name: strings.countryOfBirthLabel,
        fieldName: ErrorColumnFieldName.CountryOfBirth,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "IdNumber",
        name: strings.idNumber,
        fieldName: ErrorColumnFieldName.IdNumber,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "SocialSecurityNumber",
        name: strings.socialSecurityNumberLabel,
        fieldName: ErrorColumnFieldName.SocialSecurityNumber,
        minWidth: 100,
        maxWidth: 150,
        isResizable: true,
    },
    {
        key: "AlsoKnownAs",
        name: strings.alsoKnownAsLabel,
        fieldName: ErrorColumnFieldName.AlsoKnownAs,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "EUSectoralLegislatureBasisId",
        name: strings.EUSecLegBasisLabel,
        fieldName: ErrorColumnFieldName.EUSectoralLegislativeBasis,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "InternalCARefNo",
        name: strings.assessingCALabel,
        fieldName: ErrorColumnFieldName.InternalCARefNo,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "DateOfAssessment",
        name: strings.dateOfAssessmentLabel,
        fieldName: ErrorColumnFieldName.DateOfAssessment,
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
    }
];